/** @jsx jsx */
import { Box, Grid } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { EntityType } from "@/core/types";
import { RelatedEntities } from "@/data/related";

import { RelatedEntitiesList } from "./_components/RelatedEntitiesList";
import { RelatedEntitiesMenu } from "./_components/RelatedEntitiesMenu";
import { RelatedEntitiesNavProvider } from "./_components/RelatedEntitiesNavContext";

interface RelatedEntitiesTabsProps {
  entityType: EntityType;
  entityId: string | number;
  relatedEntities: RelatedEntities;
}

export const RelatedEntitiesTabs: FC<RelatedEntitiesTabsProps> = ({ entityType, entityId, relatedEntities }) => {
  return (
    <RelatedEntitiesNavProvider relatedEntities={relatedEntities}>
      <Grid columns={[null, null, null, "3fr 9fr"]} gap={["xs", null, null, "sm"]}>
        <Box>
          <RelatedEntitiesMenu relatedEntities={relatedEntities} />
        </Box>

        <Box px={["0", null, "sm", "0"]}>
          <RelatedEntitiesList relatedEntities={relatedEntities} entityType={entityType} entityId={entityId} />
        </Box>
      </Grid>
    </RelatedEntitiesNavProvider>
  );
};
